export const copyType = (params) => {
  if (
    params.data.CopyType === "D - CONT." ||
    params.data.CopyType === "TSDF - CONTINUATION"
  ) {
    params.data.CopyType = "TSDF - CONTINUATION";
  } else if (
    params.data.CopyType === "D - TSDF" ||
    params.data.CopyType === "D" ||
    params.data.CopyType === "TSDF"
  ) {
    params.data.CopyType = "TSDF";
  } else if (
    params.data.CopyType === "G - CONT." ||
    params.data.Copytype === "GEN. - CONTINUATION"
  ) {
    params.data.CopyType = "GEN. - CONTINUATION";
  } else if (
    params.data.CopyType === "G - GENERATOR" ||
    params.data.CopyType === "GENERATOR"
  ) {
    params.data.CopyType = "GENERATOR";
  } else if (
    params.data.CopyType === "FOREIGN D - CONT." ||
    params.data.CopyType === "TSDF CONTINUATION - OUT OF STATE"
  ) {
    params.data.CopyType = "TSDF CONTINUATION - OUT OF STATE";
  } else if (
    params.data.CopyType === "FOREIGN D - TSDF" ||
    params.data.CopyType === "TSDF - OUT OF STATE"
  ) {
    params.data.CopyType = "TSDF - OUT OF STATE";
  } else if (
    params.data.CopyType === "FOREIGN G -GENERATOR" ||
    params.data.CopyType === "GENERATOR - OUT OF STATE"
  ) {
    params.data.CopyType = "GENERATOR - OUT OF STATE";
  } else if (
    params.data.CopyType === "CORRECTION LETTER" ||
    params.data.CopyType === "CORRECTION LETTER ++"
  ) {
    params.data.CopyType = "CORRECTION LETTER ++";
  } else if (params.data.CopyType === "TSDF - E-Manifest") {
    params.data.CopyType = "TSDF - E-Manifest";
  } else {
    params.data.CopyType = "UNKNOWN";
  }
  return params.data.CopyType;
};
